import { IMap } from '@/types/posts';

export const maps = (): IMap[] => [
  {
    id: 1,
    img: '/images/maps/Ascent.webp',
    mapPosition: [
      { id: 'Ascent_1', name: 'A' },
      { id: 'Ascent_2', name: 'B' },
      { id: 'Ascent_3', name: 'BaseAtacante' },
      { id: 'Ascent_4', name: 'BaseDefensora' },
      { id: 'Ascent_5', name: 'Meio' },
      { id: 'Ascent_6', name: 'Outra' },
    ],
    name: 'Ascent',
  },
  {
    id: 2,
    img: '/images/maps/Bind.webp',
    mapPosition: [
      { id: 'Bind_1', name: 'A' },
      { id: 'Bind_2', name: 'B' },
      { id: 'Bind_3', name: 'BaseAtacante' },
      { id: 'Bind_4', name: 'BaseDefensora' },
      { id: 'Bind_5', name: 'Meio' },
      { id: 'Bind_6', name: 'Outra' },
    ],
    name: 'Bind',
  },
  {
    id: 3,
    img: '/images/maps/Haven.webp',
    mapPosition: [
      { id: 'Haven_1', name: 'A' },
      { id: 'Haven_2', name: 'B' },
      { id: 'Haven_3', name: 'C' },
      { id: 'Haven_4', name: 'BaseAtacante' },
      { id: 'Haven_5', name: 'BaseDefensora' },
      { id: 'Haven_6', name: 'Meio' },
      { id: 'Haven_7', name: 'Outra' },
    ],
    name: 'Haven',
  },
  {
    id: 4,
    img: '/images/maps/Split.webp',
    mapPosition: [
      { id: 'Split_1', name: 'A' },
      { id: 'Split_2', name: 'B' },
      { id: 'Split_3', name: 'BaseAtacante' },
      { id: 'Split_4', name: 'BaseDefensora' },
      { id: 'Split_5', name: 'Meio' },
      { id: 'Split_6', name: 'Outra' },
    ],
    name: 'Split',
  },
  {
    id: 5,
    img: '/images/maps/Breeze.webp',
    mapPosition: [
      { id: 'Breeze_1', name: 'A' },
      { id: 'Breeze_2', name: 'B' },
      { id: 'Breeze_3', name: 'BaseAtacante' },
      { id: 'Breeze_4', name: 'BaseDefensora' },
      { id: 'Breeze_5', name: 'Meio' },
      { id: 'Breeze_6', name: 'Outra' },
    ],
    name: 'Breeze',
  },
  {
    id: 6,
    img: '/images/maps/Fracture.webp',
    mapPosition: [
      { id: 'Fracture_1', name: 'A' },
      { id: 'Fracture_2', name: 'B' },
      { id: 'Fracture_3', name: 'BaseAtacante' },
      { id: 'Fracture_4', name: 'BaseDefensora' },
      { id: 'Fracture_5', name: 'Meio' },
      { id: 'Fracture_6', name: 'Outra' },
    ],
    name: 'Fracture',
  },
  {
    id: 7,
    img: '/images/maps/Icebox.webp',
    mapPosition: [
      { id: 'Icebox_1', name: 'A' },
      { id: 'Icebox_2', name: 'B' },
      { id: 'Icebox_3', name: 'BaseAtacante' },
      { id: 'Icebox_4', name: 'BaseDefensora' },
      { id: 'Icebox_5', name: 'Meio' },
      { id: 'Icebox_6', name: 'Outra' },
    ],
    name: 'Icebox',
  },
];
